import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import IconButton from '@mui/material/IconButton'
import Cookies from 'js-cookie'
const facebookLink = 'https://www.facebook.com/ClinicalNotesAI/'
const instagramLink = 'https://www.instagram.com/clinicallyai/'
const linkedinLink = 'https://www.linkedin.com/company/clinical-notes-ai/'

const Footer = () => {
  // If webView cookie is present, set webView
  const webView = Cookies.get('webview') === 'true'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
      }}
    >
      {!webView && (
        <Box sx={{ mb: 2, mt: 4 }}>
          <IconButton
            sx={{
              backgroundColor: 'primary.main',
              color: 'white',
            }}
            aria-label="facebook"
            href={facebookLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            sx={{
              backgroundColor: 'primary.main',
              color: 'white',
              mx: 2,
            }}
            aria-label="instagram"
            target="_blank"
            rel="noopener noreferrer"
            href={instagramLink}
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            sx={{
              backgroundColor: 'primary.main',
              color: 'white',
            }}
            aria-label="linkedin"
            target="_blank"
            rel="noopener noreferrer"
            href={linkedinLink}
          >
            <LinkedInIcon />
          </IconButton>
        </Box>
      )}
      <Typography variant="body2" color="text.secondary" align="center">
        {'© '}
        {new Date().getFullYear()} Clinical Notes AI Inc.
        <br />
        By using this site, you agree to our{' '}
        <Link
          href="https://www.clinicalnotes.ai/terms-of-service.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </Link>
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center">
        See our{' '}
        <Link
          href="https://www.clinicalnotes.ai/privacy-policy.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Link>
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center">
        App Version 283
      </Typography>
      <Typography variant="body2" align="center">
        <Link href="https://app.clinicalnotes.ai/help">Contact Us</Link>
      </Typography>
      <Typography variant="body2" align="center">
        <Link href="https://status.clinicalnotes.ai/" target="_blank" rel="noopener noreferrer">
          Check the status of the site here
        </Link>
      </Typography>
    </Box>
  )
}

export default Footer
